import { CopyOutlined } from '@ant-design/icons';
import { Button as AntButton, Tooltip, Card } from 'antd';
import { NotificationManager } from '../notification-manager';

interface DeepLinkText {
    text: string | null;
}

const clipboard = (text: string) => {
    navigator.clipboard.writeText(text);
    NotificationManager.showSuccess('URL copied to clipboard');
};

export const DeepLinkLabel = (props: DeepLinkText) => {
    return (
        <Card title="Marketing: Game deeplink">
            <span>
                {props.text}
                <Tooltip title="Copy deep link url">
                    <AntButton
                        type="link"
                        icon={<CopyOutlined />}
                        onClick={() => clipboard(props.text || '')}
                    />
                </Tooltip>
            </span>
        </Card>
    );
};
